import { useQuery, useMutation } from "react-query";
import { toast } from "react-toastify";
import { SoftwareServices } from "../api";

const onDefaultError = (error) => {
  toast.error(error.message);
};
/**
 * Hook for Admin Software Master section
 */
const useListSoftware = ([page_no], onSuccess, onError = onDefaultError) => {
  return useQuery(["software-list", page_no], SoftwareServices.SoftwareList, {
    onSuccess,
    keepPreviousData: true,
    onError,
  });
};
const useAddSoftware = (onSuccess, onError = onDefaultError) => {
  return useMutation(SoftwareServices.addSoftware, {
    onSuccess,
    onError,
  });
};
const useUpdateSoftware = (onSuccess, onError = onDefaultError) => {
  return useMutation(SoftwareServices.updateSoftware, {
    onSuccess,
    onError,
  });
};
const useViewSoftware = (id, onSuccess, onError = onDefaultError) => {
  return useQuery(
    "software-view",
    () => SoftwareServices.viewSoftware({ id }),
    {
      onSuccess,
      onError,
    }
  );
};
const useSoftwareDelete = (onSuccess, onError = onDefaultError) => {
  return useMutation(SoftwareServices.deleteSoftware, {
    onSuccess,
    onError,
  });
};

export {
  useListSoftware,
  useAddSoftware,
  useUpdateSoftware,
  useViewSoftware,
  useSoftwareDelete,
};
